// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notice-content {\n  padding: 10px 20px;\n}\n.notice-title {\n  font-weight: 600;\n  font-size: 1.1em;\n  padding: 10px 20px;\n}", ""]);
// Exports
module.exports = exports;
